import Breadcrumb from "./breadcrumb";

interface NavItem {
    name: string;
    target: string | undefined;
}

interface Props extends React.PropsWithChildren {
    readonly items: readonly NavItem[];
    readonly onItemRename?: (item: NavItem, newName: string) => void;
    readonly isLoading?: boolean;
}

const NavBreadcrumb: React.FC<React.PropsWithChildren<Props>> = ({ items, onItemRename, isLoading }) => {
    const onItemClicked = (item: NavItem) => {
        if (item.target !== undefined) {
            history.pushState(null, "", item.target);
        }
    };

    return (
        <Breadcrumb
            items={items}
            currentItem={items[items.length - 1]}
            nameForItem={t => t.name}
            onItemClicked={onItemClicked}
            onItemRename={onItemRename}
            size={26}
            isLoading={isLoading}
        />
    );
};

export default NavBreadcrumb;
